import { IconButton, SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { alpha, useTheme } from "@mui/material/styles";
import { createElement } from "react";

interface FilterToggleIcon {
    onClick: () => void;
    active: boolean;
    icon: OverridableComponent<SvgIconTypeMap>;
    disabled?: boolean;
}

const FilterToggleIcon = ({ icon, onClick, active, disabled }: FilterToggleIcon) => {
    const theme = useTheme();
    
    return (
        <IconButton
            onClick={onClick}
            size={"small"}
            color={active ? "primary" : "default"}
            disabled={disabled}
            sx={{
                opacity: disabled ? 0.7 : 1,
                backgroundColor: active ? theme.palette.semantic.button.primary : "default",
                "&.Mui-disabled": {
                    color: active ? `${theme.palette.semantic.button.primary}80` : undefined,
                },
                "&:hover": {
                    backgroundColor: active ? alpha(theme.palette.semantic.button.primary, 0.75) : "rgba(0, 0, 0, 0.04)",
                },
            }}
        >
            {createElement(icon)}
        </IconButton>
    );
};

export default FilterToggleIcon;
